export const implementerTypes = [
  { label: "Organizacion civil", value: "CIVIL_ORGANIZATION" },
  { label: "Gobierno", value: "GOVERNMENT" }
]
